import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { PRECHAT_MESSAGE_FIELD_ID } from 'sdk';

import { useSDK } from '../../../app';
import { MessageFieldChat } from '../fields/messageField/chat';
import { useForm } from './hooks/useForm';

const ChatForm = observer((): ReactElement | null => {
	const rootStore = useSDK();
	const { setMessage, onSendClick, onSuggestionSelect, message } = useForm(rootStore);
	if (
		rootStore.conversationsStore.isLatestConversationResolved &&
		!rootStore.welcomeDataStore.data?.isInlinePrechat
	) {
		return null;
	}
	return (
		<MessageFieldChat
			error={rootStore.formsStore.chatFormErrors[PRECHAT_MESSAGE_FIELD_ID]}
			value={message}
			disabled={
				rootStore.startNewConversationRequestStatus.isPending ||
				rootStore.newConversationHistoryRequestStatus.isPending
			}
			onSendClick={onSendClick}
			onChange={setMessage}
			onSuggestionSelect={onSuggestionSelect}
		/>
	);
});

export { ChatForm };
